module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/name/suffix.js
// module id = 2028
// module chunks = 0